import { render } from "./GeneralDialog.vue?vue&type=template&id=02ec089d"
import script from "./GeneralDialog.vue?vue&type=script&lang=js"
export * from "./GeneralDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__